import {combineReducers} from 'redux'
import { clientReducer } from './reducer'

export default combineReducers({
    clientReducer
})